import React, { MouseEvent } from 'react';
import styled from 'styled-components';
import { colors } from '../styles/GlobalStyles';
import {  ShowModalData } from '../services/api';

const FooterWrapper = styled.footer`
  background-color: ${colors.navyBlue};
  color: ${colors.offWhite};
  padding: 15px 40px;
  text-align: center;
  font-size: 0.9em;
  margin-top: auto; /* Push footer to the bottom if content is short */

  @media (max-width: 768px) {
    padding: 10px 20px;
    font-size: 0.8em;
  }
`;

const Alink = styled.a`
    text-decoration: none !important;
    color: ${colors.offWhite};
`;

const Footer: React.FC<ShowModalData> = ({show, updateShow}) => {
  const currentYear = new Date().getFullYear();

    const clickHandler = (event: MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault();
        updateShow(true)
    }
  return (
    <FooterWrapper>
      © {currentYear} VendingRebates.com - All Rights Reserved. <br />
      <Alink href={"/"}  onClick={clickHandler}>Terms of use</Alink>
    </FooterWrapper>
  );
};

export default Footer; 